import { FC, ReactNode } from "react";
import useScript from "react-script-hook";

interface Props {
  children: ReactNode;
}

export const GoogleMapsApiProvider: FC<Props> = ({ children }) => {
  // load external Google API script that is required in order to make the autocomplete work
  const [loading, error] = useScript({
    src: `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_AND_PLACES_API_KEY_FOR_FRONT_END}&libraries=places`,
    // checkForExisting: true,
  });

  return !loading ? <>{children}</> : null;
};
